// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-detail/components/edit-pads/edit-pads.less
// module id = 3362
// module chunks = 0